import { SET_SIDEBAR_COLLAPSE } from "../actions/sidebarCollapse";

const initialState = false;

export const sidebarCollapse = (state = initialState, action) => {
    switch (action.type) {
        case SET_SIDEBAR_COLLAPSE:
            return action.payload; 
        default:
            return state;
    }
};